module.exports = __webpack_public_path__ + "img/portrait-021.d16d31ab.jpg";